import React, { useEffect, useState } from "react";
import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import useStyles from "./styles";
import { Lock, Report } from "@material-ui/icons";
import { UserRuleContainer } from "./components/UserRuleContainer";
import { UserStatusCounter } from "./components/UserStatusCounter";
import { useI18n } from "../../hooks/useI18n";

export const UnwantedBehaviour = () => {
  const theme = useTheme();
  const styles = useStyles();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useI18n();

  return (
    <>
      <Grid container spacing={2} direction={mobile ? "column" : "row"}>
        <Grid item xs={12} lg={6}>
          <UserStatusCounter
            title={t("common.messages.suspiciousUsers")}
            status={"suspicious"}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <UserStatusCounter
            title={t("common.messages.lockedUsers")}
            status={"locked"}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <UserRuleContainer
            title={"Mark user suspicious when"}
            icon={<Report className={styles.sectionIconWarning} />}
            outCome={"suspicious"}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <UserRuleContainer
            title={"Lock user when"}
            icon={<Lock className={styles.sectionIconError} />}
            outCome={"lock"}
          />
        </Grid>
      </Grid>
    </>
  );
};
